import {Component, Input} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-tab',
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
      .pane {
        width: 100%;
        height: 100%;
      }
  `],
})
export class TabComponent {
  @Input() tabTitle = '';
  @Input() tabTitleHTML: SafeHtml;
  @Input() tabValue;
  @Input() active = false;
  @Input() hasCount = true;
  @Input() count = 0;
}
